/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteWorkRate } from './';
import {
    QuoteWorkRateFromJSON,
    QuoteWorkRateFromJSONTyped,
    QuoteWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteTemplateDetailsResource
 */
export interface TimeAndMaterialsQuoteTemplateDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsQuoteTemplateDetailsResource
     */
    projectScope?: string;
    /**
     * 
     * @type {QuoteWorkRate}
     * @memberof TimeAndMaterialsQuoteTemplateDetailsResource
     */
    workRate?: QuoteWorkRate;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteTemplateDetailsResource interface.
 */
export function instanceOfTimeAndMaterialsQuoteTemplateDetailsResource(value: object): value is TimeAndMaterialsQuoteTemplateDetailsResource {
    return true;
}

export function TimeAndMaterialsQuoteTemplateDetailsResourceFromJSON(json: any): TimeAndMaterialsQuoteTemplateDetailsResource {
    return TimeAndMaterialsQuoteTemplateDetailsResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteTemplateDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteTemplateDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': json['workRate'] == null ? undefined : QuoteWorkRateFromJSON(json['workRate']),
    };
}

export function TimeAndMaterialsQuoteTemplateDetailsResourceToJSON(value?: TimeAndMaterialsQuoteTemplateDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': QuoteWorkRateToJSON(value['workRate']),
    };
}

